/**
 * Implements listeners for cart item quatity buttons and cart item remove buttons in both the old
 * and the new WooCommerce carts.
 *
 * The listeners trigger cart icons to update.
 */
(() => {
    /**
     * Triggers an update in cart icons.
     */
    function update() {
        document
            .querySelectorAll('.js-woocommerce-cart-icon')
            .forEach((icon) => {
                icon.dispatchEvent(new Event('cart-updated'));
            });
    }

    /**
     * Adding click listeners to high level containers to avoid having to create new listeners when
     * WooCommerce JavaScript modifies the DOM (which would wipe out low level listeners).
     */
    document
        .querySelectorAll(
            // old cart
            '.woocommerce:has(> form.woocommerce-cart-form), ' +
                // new cart
                '.wp-block-woocommerce-cart'
        )
        .forEach((container) => {
            container.addEventListener('click', (e) => {
                // console.log('click event', e.target);

                if (
                    e.target.matches(
                        // old cart
                        'button[name=update_cart], a.remove, ' +
                            // new cart
                            'button.wc-block-components-quantity-selector__button, ' +
                            'button.wc-block-cart-item__remove-link'
                    )
                ) {
                    update();
                }
            });
        });
})();
